import About from '../pages/About';
import Service from '../pages/Services';
import Contact from '../pages/Contact';
import FAQ from '../pages/FAQ';
import Home from '../pages/Home';

const routes = [
 
  {
    path: '/',        // This will show the same as /
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/services',
    element: <Service />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/faq',
    element: <FAQ />,
  },
];

export default routes;